import React from 'react';
import { Link } from 'react-router-dom';

const StorefrontAppointmentHistoryEmpty = ({ companyUrl }) => (
  <div className="sf-ah-empty">
    <p className="sf-ah-empty__title">No appointments yet</p>
    <p className="sf-ah-empty__text">
      When you book on this storefront, your visits will show up here.
    </p>
    <Link className="sf-ah-empty__cta" to={`/book/${companyUrl}`}>
      Book an appointment
    </Link>
  </div>
);

export default StorefrontAppointmentHistoryEmpty;
